'use strict';

import { platformHandler } from '../../platforms/PlatformHandler'

/*
import WebViewFW from '../components/flipwitComponents/WebViewFW';
import {  RaisedButton, } from 'carbon-ui'

var i = 0;

class Home extends Component {
  onButtonPress(evt){
    this._child.sendMessage("algo -" + i);
    i ++;
  };

  onReceiveMessage(msg){
    
  };

  render() {
  return (
        <View style={{ flex: 1 }}>
          <View style={{ flex: 1 }}> 
            <WebViewFW ref={(child) => { this._child = child; }}
                urlWebView={'http://192.168.1.18/flipwit/iframe.html'}
                height={"175"}
                handleReceiveMessage={this.onReceiveMessage.bind(this)}
              />
          </View>
          <View style={{ flex: 1 }}>
              <RaisedButton onPress={this.onButtonPress.bind(this)} >Alog</RaisedButton>
            </View>
      </View>
    );
  }
}
 */

import React, { Component, Fragment } from 'react';
//import { Platform } from 'react-native';

import IframeComm from "react-iframe-comm";
//import {WebView} from 'react-native';  

class WebViewFW extends Component {
  constructor(props){
    super(props);

    //this.onReceiveMessage = this.onReceiveMessage.bind(this);
    //this.onHandleReady = this.onHandleReady.bind(this);
  }

  sendMessage = ( msg ) => {
    if( this._child ){
      this._child.sendMessage(msg);
      /*if (Platform.OS === 'web'){
        this._child.sendMessage(msg);
      }
      else{
        this._child.postMessage(msg);
      }*/
    }    
  };

  // parent received a message from iframe
  onReceiveMessage = (e) => {
    var msg;
    msg = e.data;
    
    /*if (Platform.OS === 'web'){
      msg = e.data;
    }
    else{
      msg = e.nativeEvent.data;
    }*/
    
    if(msg.source!==undefined) {
      if(msg.source==="react-devtools-bridge") return;
      if(msg.source==="react-devtools-content-script") return;
    }

    console.log('El mensaje',msg);
    let msgObj = JSON.parse( msg );

    const { handleReceiveMessage, name } = this.props;
    console.log('1 Llego un mensaje de iframe ',e,e.data.nameIframe,msgObj.nameIframe)
    console.log('Llego un mensaje de iframe ',name,msg)

    if (handleReceiveMessage && msgObj.nameIframe===name) {
        console.log('lo procesa para ',name)
        handleReceiveMessage( msg );
    }
  };

  onHandleReady = () => {
    const { handleReady } = this.props;
    if (handleReady) {
        handleReady( );
    }
  }

  render() {

    console.log('this props webview ',this.props)
    var pointerEventsTmp = 'auto';
    
    if( this.props.pointerEvents ){
      pointerEventsTmp = this.props.pointerEvents;
    }
    
    let style = {}
    style.pointerEvents = pointerEventsTmp;    
    if(this.props.style!==undefined) style = {...style,...this.props.style};    

    return (
        <IframeComm key={this.props.name} ref={(child) => { this._child = child; }}
          attributes={{
              name: this.props.name,
              key: this.props.name,
              allow:"autoplay",
              sandbox:"allow-same-origin allow-scripts allow-popups allow-forms allow-popups-to-escape-sandbox",
              id:this.props.id,
              src: this.props.urlWebView,
              width: "100%",
              height: this.props.height,
              //scrolling: "no",
              style: style,
          }}
          postMessageData={{currentLang:platformHandler.getLanguage()}}
          handleReceiveMessage={this.onReceiveMessage}
          handleReady={this.onHandleReady}
        />
    );
       /*return (
        <IframeComm ref={(child) => { this._child = child; }}
          attributes={{
              src: this.props.urlWebView,
              width: "100%",
              height: this.props.height,
              scrolling: "no",
              style: { pointerEvents: pointerEventsTmp },
          }}
          postMessageData={''}
          handleReceiveMessage={this.onReceiveMessage}
          handleReady={this.onHandleReady} />        
      );

    /*if (Platform.OS === 'web'){
      var pointerEventsTmp = 'auto';
      if( this.props.pointerEvents ){
        pointerEventsTmp = this.props.pointerEvents;
      }
      return (
        <IframeComm ref={(child) => { this._child = child; }}
          attributes={{
              src: this.props.urlWebView,
              width: "100%",
              height: this.props.height,
              scrolling: "no",
              style: { pointerEvents: pointerEventsTmp },
          }}
          postMessageData={''}
          handleReceiveMessage={this.onReceiveMessage}
          handleReady={this.onHandleReady}
        />
      );
    }
    else{
      return (
        <div>hola</div>
    );
        /*{/*<WebView ref={(child) => { this._child = child; }}
            source={{uri: this.props.urlWebView }}
            style={ {flex: 1}}
            onMessage={this.onReceiveMessage.bind(this)}
            onLoad={this.onHandleReady.bind(this)}
          />*///}
    //}
  }
}

export default WebViewFW;


// WEBPACK FOOTER //
// ./src/containers/components/flipwitComponents/WebViewFW.js